import { useEffect, useRef } from "react";

function EmbeddedForm({ subheading, formId }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const cleanup = () => {
      const existingScript = document.querySelector(
        `script[data-uid="${formId}"]`
      );
      if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
      }

      const existingForm = document.querySelector("form");
      if (existingForm && existingForm.parentNode) {
        existingForm.parentNode.removeChild(existingForm);
      }
    };

    cleanup();

    const script = document.createElement("script");
    script.src = `https://campapex.kit.com/${formId}/index.js`;
    script.async = true;
    script.setAttribute("data-uid", formId);

    containerRef.current.appendChild(script);

    return cleanup;
  }, [formId]);

  return (
    <>
      <style>
        {`
          .formkit-powered-by-convertkit {
            display: none !important;
          }
        `}
      </style>
      <div className="relative bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-3xl p-8 mx-4 md:mx-auto max-w-2xl border-[5px] border-dashed border-[#FFD700] shadow-2xl">
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-6xl filter drop-shadow-lg">
          🔔
        </div>
        <div className="flex flex-col items-center text-center">
          <h2 className="font-['Cabin_Sketch'] text-4xl font-bold mb-4 text-[#FFFEF7] text-shadow-lg">
            Raffle & Competition Updates
          </h2>
          {subheading && (
            <p className="text-[#FFFEF7] text-lg font-semibold mb-4 leading-relaxed">
              {subheading}
            </p>
          )}
          <div ref={containerRef} className="w-full" />
        </div>
      </div>
      <style jsx>{`
        .text-shadow-lg {
          text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.3);
        }
      `}</style>
    </>
  );
}

export default EmbeddedForm;
